// extracted by mini-css-extract-plugin
module.exports = {"bottomArticleAd":"styles_bottomArticleAd__qK3mD"};